import React from 'react';
import { Radio } from '@core-ui/radio';
import { useLocalize } from '@core-ui/localization-provider';
import { ReviewRatings } from '@core-ui/review-ratings';
import { styled } from '@core-ui/react-stitch';
import { StarSize } from '@core-ui/review-ratings/types';
import { RATING_FACET_ALL_REVIEWED } from './localization-tokens';
import { StarRatingFacetProps } from './types';

export const StarRatingFacet = ({
  value,
  applied,
  name,
  onChange,
  facetName,
  isMobile,
}: StarRatingFacetProps) => {
  const { localize } = useLocalize();

  const starSize: StarSize = isMobile ? StarSize.large : StarSize.medium;

  const StarRatings = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {value !== '1' ? (
        <React.Fragment>
          {/* @ts-ignore [starRating is supposed to be a number] */}
          <ReviewRatings starRating={value} starSize={starSize} />
          <span data-testId='rating-text'>
            {name?.replace(/[0-9]/g, '')?.replace('plus', '+')}
          </span>
        </React.Fragment>
      ) : (
        <span data-testId='all-reviewed'>
          {localize(RATING_FACET_ALL_REVIEWED)}
        </span>
      )}
    </div>
  );

  const LabelStyle = styled.div`
    label {
      display: flex;
      align-items: center;
    }
  `;

  const deselect = (event: React.MouseEvent<HTMLElement>) => {
    if (applied) {
      onChange({ currentTarget: { checked: false } });
      event.preventDefault();
    }
  };

  return (
    <React.Fragment>
      <LabelStyle onClick={deselect}>
        {/* @ts-ignore [missing id attribute] */}
        <Radio
          checked={applied}
          label={StarRatings}
          name={facetName}
          onChange={onChange}
          styles={{ labelText: { display: 'flex' } }}
        />
      </LabelStyle>
    </React.Fragment>
  );
};
